module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country":"Country","noCountryFound":"Not found"}}')
  delete Component.options._Ctor
}
